<template>
    <v-container class="pt-12 pb-6">
        <div class="text-h3 grey--text text--darken-4 font-weight-light text-center">
            Working at Prospira
        </div>

        <v-row justify="center" class="pt-6">
            <v-col
                cols="8"
                md="4"
            >
                <v-card flat>
                    <v-card-title class="d-flex justify-center">
                        <div class="title d-flex justify-center align-center pa-4 text-overline my-6">
                            Our Mission
                        </div>
                    </v-card-title>

                    <v-card-subtitle
                        class="grey--text text--darken-4 text-body-1 font-italic font-weight-medium text-center pt-3 mb-6"
                    >
                        Service Society with Superior Quality
                    </v-card-subtitle>
                </v-card>
            </v-col>
            <v-col
                cols="8"
                md="4"
            >
                <v-card flat>
                    <v-card-title class="d-flex justify-center">
                        <div class="title d-flex justify-center align-center pa-4 text-overline my-6">
                            Our Vision
                        </div>
                    </v-card-title>

                    <v-card-subtitle
                        class="grey--text text--darken-4 text-body-1 font-italic font-weight-medium text-center pt-3 mb-6"
                    >
                        Creating Value Together, Sharing Happiness Together
                    </v-card-subtitle>
                </v-card>
            </v-col>
            <v-col
                cols="8"
                md="4"
            >
                <v-card flat>
                    <v-card-title class="d-flex justify-center">
                        <div class="title d-flex flex-column justify-center align-center pa-4 text-overline my-6">
                            <div>Our Values</div>
                        </div>
                    </v-card-title>

                    <v-card-subtitle
                        class="grey--text text--darken-4 text-body-1 font-italic font-weight-medium text-center pt-3 mb-6"
                    >
                        <strong style="color: #00B1C3;">P</strong>eople First,
                        <strong style="color: #00B1C3;">D</strong>ata Driven,
                        <strong style="color: #00B1C3;">R</strong>esults Oriented
                        <strong style="color: #00B1C3;">T</strong>ime is of the Essence
                    </v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'WorkingAtProspira'
}
</script>

<style scoped>
    .title {
        border-radius: 100%;
        border: 3px solid #00B1C3;
        height: 150px;
        width: 150px;
    }
</style>